import dayjs from 'dayjs'
import { LoaderFunction, redirect } from 'react-router-dom'

import { FormattedSlot, Slot } from '@/apiTypes.ts'
import { basePath } from '@/router/paths.ts'
import { useAppointmentStore } from '@/store.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'

interface LoaderData {
  loadTime?: number
  error?: string
}

const loader: LoaderFunction<LoaderData> = async ({
  params,
}): Promise<LoaderData | Response | null> => {
  const { appointmentType, locationId } = params as {
    appointmentType: string
    category: string
    locationId: string
  }
  const { setAppointmentType, setSelectedLocation, setSelectedSlot, setSlots } =
    useAppointmentStore.getState()
  setSelectedLocation({
    emmaId: locationId,
  })
  setAppointmentType(appointmentType)

  const startTime = Date.now()
  try {
    const response = await fetchFromApi(
      `slots?type=${appointmentType}&location=${locationId}`,
    )

    if (!response.ok) {
      throw new Error(`HTTP error status: ${response.status}`)
    }

    const slots: Slot[] = await response.json()

    if (!slots || slots.length === 0) {
      redirect(basePath)
    }

    const formattedSlots: FormattedSlot[] = slots.map((slot) => ({
      ...slot,
      end: dayjs(slot.end),
      start: dayjs(slot.start),
    }))
    setSlots(formattedSlots)

    if (params.doctorId === 'all') {
      setSelectedSlot(formattedSlots[0])
    } else {
      const formattedSlotsByDoctor = formattedSlots.filter(
        (slot) => slot.practitioner.emmaId === params.doctorId,
      )
      setSelectedSlot(formattedSlotsByDoctor[0])
    }
    return { loadTime: Date.now() - startTime }
  } catch (error) {
    console.error('Error fetching appointment slots:', error)
    return {
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    }
  }
}

export type { LoaderData }
export { loader }
